import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from './api.service';
import { MetadataService } from './metadata.service';
import { AuthGuard } from './auth-guard.service';
import { ExpressionFilter, ExpressionRule, Condition, Operator } from './expression';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
  ],
  providers: [
    ApiService,
    MetadataService,
    AuthGuard
  ],
})
export class UbiCoreModule { }

export { ApiService } from './api.service';
export { AuthGuard } from './auth-guard.service';
export { MetadataService } from './metadata.service';
export { ExpressionFilter, ExpressionRule, Operator, Condition } from './expression';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/ubi-core.module.ts